export const downloadQRCode = async (route: String | string, name: String | string): Promise<any> => {
  try {
    const response = await requestBE(route);
    makeDownloadBlob([response], (name + '.png'), response.type);
  } catch (error) {
      console.error('Download failed:', error);
  }
};
